export default __webpack_public_path__ + "static/sviluppare-con-react-vantaggi-aziende-orangeloop-a167ad0926f2265a7c34091cd73bea2a.jpg";